import { PROVIDERS } from 'consts'

function usernameFormat(provider, name, simple) {
  const pageName = name.replace(/\s+/g, '')
  switch (provider) {
    case PROVIDERS['fb'].KEY: {
      const url = `facebook.com/${pageName}`
      return simple ? url : `https://${url}`
    }
    case PROVIDERS['in'].KEY: {
      const url = `instagram.com/${pageName}`
      return simple ? `@${pageName}` : `https://${url}`
    }
    case PROVIDERS['yt'].KEY: {
      const url = `youtube.com/${pageName}`
      return simple ? `/${pageName}` : `https://${url}`
    }
    case PROVIDERS['tw'].KEY: {
      const url = `twitch.tv/${pageName}`
      return simple ? `/${pageName}` : `https://${url}`
    }
    case PROVIDERS['tt'].KEY: {
      const url = `tiktok.com/${pageName}`
      return simple ? `@${pageName}` : `https://${url}`
    }
    default: {
      return ''
    }
  }
}

export default usernameFormat
